export interface IFileApp {
  fileId: string;
  urlFile: string;
  path: string;
  service: string;
  fileType: string;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface INotificationType {
  notificationTypeId: string;
  code: string;
  notificationType: string;
  fileId: string | null;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  image: IFileApp | null;
}

export interface INotificationApp {
  notificationId: string;
  notificationTypeId: string;
  fromHouseFlatId: string | null;
  toHouseFlatId: string | null;
  toUidUser: string | null;
  title: string;
  subtitle: string;
  sent: boolean;
  seen: boolean;
  visitId: string | null;
  createdAt: string;
  updatedAt: string;
  notificationType: INotificationType | null;
}

export class NotificationApp {
  notificationId: string;
  notificationTypeId: string;
  fromHouseFlatId: string | null;
  toHouseFlatId: string | null;
  toUidUser: string | null;
  title: string;
  subtitle: string;
  sent: boolean;
  seen: boolean;
  visitId: string | null;
  createdAt: string;
  updatedAt: string;
  notificationType: INotificationType | null;

  constructor(data: INotificationApp) {
    this.notificationId = data.notificationId;
    this.notificationTypeId = data.notificationTypeId;
    this.fromHouseFlatId = data.fromHouseFlatId ?? null;
    this.toHouseFlatId = data.toHouseFlatId ?? null;
    this.toUidUser = data.toUidUser ?? null;
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.sent = data.sent;
    this.seen = data.seen;
    this.visitId = data.visitId ?? null;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.notificationType = data.notificationType ?? null;
  }

  get canTap(): boolean {
    return this.notificationType?.code === 'chat';
  }
}
